import './styles.scss'
import image from '../../../Assets/Images/quote-modal-img.jpeg'
import { CSSTransition } from 'react-transition-group'
import React, { useEffect, useRef, useState } from 'react'
import CustomButton from '../../CustomButton'
import { useForm } from '../../../Hooks/useForm'
import emailjs from '@emailjs/browser'
import { solid } from '@fortawesome/fontawesome-svg-core/import.macro'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { SERVICES } from '../../../constants'

const serviceId  = process.env.REACT_APP_EMAILJS_SERVICE_ID
const templateId = process.env.REACT_APP_EMAILJS_QUOTE_TEMPLATE_ID
const publicId   = process.env.REACT_APP_EMAILJS_PUBLIC_KEY

const QuoteForm = ({ showForm, handleClose, ...props }) => {
  const formRef = useRef(null)
  const [submitted, setSubmitted] = useState(false)

  const handleClick = (e) => e?.stopPropagation()

  const { form, reset, onChange } = useForm({
    name: '',
    email: '',
    serviceType: '',
    origin: '',
    destination: '',
    msg: '',
    loading: false,
  })

  const handleChange = (e) => onChange(e.target.name, e.target.value)

  useEffect(() => {
    return reset
  }, [])

  const handleSubmit = async (e) => {
    e.preventDefault()
    onChange('loading', true)
    try {
      await emailjs.send(serviceId, templateId, form, publicId)
      setSubmitted(true)
    } catch (error) {
      console.log('ERROR', error)
    }
    onChange('loading', false)
  }

  const handleCloseAndReset = () => {
    setSubmitted(false)
    reset()
    handleClose()
  }

  return (
    <CSSTransition
      in={showForm}
      nodeRef={formRef}
      timeout={300}
      unmountOnExit
      classNames="quote-form"
    >
      <div
        ref={formRef}
        onClick={handleClick}
        className="quote-form"
        {...props}
      >
        <div className="quote-form__image">
          <img src={image} alt="" />
        </div>

        <div className="quote-form__content">
          {submitted ? (
            <div className="quote-form__success">
              <div className="quote-form__success__icon">
                <FontAwesomeIcon icon={solid('circle-check')} />
              </div>
              <h4>Quote Request Sent!</h4>
              <p>Thank you! Our team will review your request and get back to you within 24 hours.</p>
              <button className="quote-form__success__btn" onClick={handleCloseAndReset}>
                Close
              </button>
            </div>
          ) : (
            <>
              <div className="quote-form__header">
                <h5 className="title">Get A Free Quote</h5>
                <p className="subtitle">Fill in the details below and we'll get back to you within 24 hours.</p>
              </div>

              <form onSubmit={handleSubmit}>
                {/* Row 1: Name + Email */}
                <div className="quote-form__row">
                  <div className="quote-form__field">
                    <label>Full Name</label>
                    <input
                      type="text"
                      name="name"
                      placeholder="Your full name"
                      value={form.name}
                      onChange={handleChange}
                      required
                    />
                  </div>
                  <div className="quote-form__field">
                    <label>Email Address</label>
                    <input
                      type="email"
                      name="email"
                      placeholder="Your email"
                      value={form.email}
                      onChange={handleChange}
                      required
                    />
                  </div>
                </div>

                {/* Service type */}
                <div className="quote-form__field">
                  <label>Service Type</label>
                  <select
                    name="serviceType"
                    value={form.serviceType}
                    onChange={handleChange}
                    required
                  >
                    <option value="" disabled>Select a service</option>
                    {SERVICES.map((s) => (
                      <option key={s} value={s}>{s}</option>
                    ))}
                  </select>
                </div>

                {/* Row 2: Origin + Destination */}
                <div className="quote-form__row">
                  <div className="quote-form__field">
                    <label>Origin</label>
                    <input
                      type="text"
                      name="origin"
                      placeholder="City or country"
                      value={form.origin}
                      onChange={handleChange}
                      required
                    />
                  </div>
                  <div className="quote-form__field">
                    <label>Destination</label>
                    <input
                      type="text"
                      name="destination"
                      placeholder="City or country"
                      value={form.destination}
                      onChange={handleChange}
                      required
                    />
                  </div>
                </div>

                {/* Message */}
                <div className="quote-form__field">
                  <label>Additional Details <span className="optional">(optional)</span></label>
                  <textarea
                    name="msg"
                    rows={3}
                    placeholder="Package weight, dimensions, special requirements..."
                    value={form.msg}
                    onChange={handleChange}
                  />
                </div>

                <CustomButton
                  loading={form.loading}
                  otherClassName="submit"
                  type="submit"
                  label="Request Quote"
                />
              </form>
            </>
          )}
        </div>
      </div>
    </CSSTransition>
  )
}

export default QuoteForm
